import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api } from "../api";
import { AuthLayout, inputCls, btnCls } from "./Login";

export default function ResetPassword() {
  const { token } = useParams();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Mindestens 8 Zeichen");
    if (pw !== pw2) return toast.error("Die Passwörter stimmen nicht überein");
    try { await api("/auth/reset-password", { method: "POST", body: { token, password: pw } }); setDone(true); } catch (er) { toast.error(er.message); }
    return undefined;
  };
  return (
    <AuthLayout overline="Konto" title="Neues Passwort">
      {done ? <p className="text-[#A1A1AA]" data-testid="reset-done">Dein Passwort wurde geändert. <Link to="/training/login" className="text-[#c1ff72] underline">Jetzt anmelden</Link></p> : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <div><Label>Neues Passwort</Label><Input type="password" autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} className={`${inputCls} mt-2`} data-testid="reset-password" /></div>
          <div><Label>Wiederholen</Label><Input type="password" autoComplete="new-password" value={pw2} onChange={(e) => setPw2(e.target.value)} className={`${inputCls} mt-2`} data-testid="reset-password-repeat" /></div>
          <button className={btnCls} data-testid="reset-submit">Speichern</button>
        </form>
      )}
    </AuthLayout>
  );
}
